import { CustomsMappers } from '../mappers';
import { ApiResult, urlMaker, caller } from '@shared/utils';
import { CustomsPingResult } from '../types/ping';

export class CustomsPingService {
  public static async get(): Promise<ApiResult<number, CustomsPingResult>> {
    const url = urlMaker('/api/warehouse/customs/ping');

    try {
      const response = await caller(url);

      if (response.ok) {
        const { data } = await response.json();
        const mappedData = CustomsMappers.Ping.fromApi(data);

        return new ApiResult(200, mappedData, null);
      }
    } catch (e) {}

    return new ApiResult(400, { status: 'warning' }, null);
  }
}
